/*
  Keeps engraved lipsticks and the hidden "Custom Engraving" line in step.

  Engraved lipsticks carry properties.Engraving = "NS". The cart holds ONE
  Rs.0 "Custom Engraving" line whose properties.Engravings lists every one,
  shade first ("Her Drama – AB, Want Her – NS"), so the warehouse never has
  to pair initials with lipsticks by position. Shopflo's COD rule keys off that product, and the
  drawer cannot show line properties, so it is also the shopper's only
  visible sign of the engraving.

  Why one line, not one per set of initials: Shopflo's drawer deletes items
  by VARIANT id (/cart/change.js {id: variantId, quantity: 0}), and Shopify
  then removes every line of that variant. Two engraving lines would both
  vanish when the shopper deletes one. With a single line, "remove Custom
  Engraving" means "remove all engravings", which is what actually happens.

  Rules, applied one fix per pass until the cart is consistent:
    - no engraved lipsticks         -> remove any Custom Engraving line
    - lipsticks but no engraving    -> the shopper removed it: strip Engraving
      line                             from every lipstick (each line removed
                                       and re-added, the only way to drop a
                                       property); they stay as stock lipsticks
    - more than one engraving line  -> keep the first, remove the rest (an
      (each engraved add brings        engraved add always brings its own)
      its own)
    - summary or quantity wrong     -> replace the line with the merged list,
                                       quantity 1

  Runs after any cart write on the page completes (Shopflo's drawer posts
  FLO_ITEM_UPDATE and then calls /cart/change.js itself) and once on page
  load. All writes go through window.fetch, which Shopflo wraps, and an open
  Shopflo drawer is re-rendered afterwards so it never shows a removed line.

  The load-time check only runs while localStorage says an engraving was
  added, so ordinary visitors pay nothing.
*/
(function () {
  var ENGRAVING_VARIANT = String(window.IrisEngravingVariant || '');
  if (!ENGRAVING_VARIANT) return;
  var FLAG = 'irisEngrCart';
  // Property on the Custom Engraving line listing every engraving in the cart.
  var SUMMARY = 'Engravings';
  var running = false;
  var again = false;
  var timer = null;

  function flag(on) {
    try {
      if (on) localStorage.setItem(FLAG, '1');
      else localStorage.removeItem(FLAG);
    } catch (e) { /* private mode */ }
  }
  function flagged() {
    try { return localStorage.getItem(FLAG) === '1'; } catch (e) { return false; }
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
      irisInternal: true, // unknown init keys are ignored by fetch; marks our own writes
    }).then(function (r) { return r.json(); });
  }

  /* Shade next to its initials, so nobody pairs them up by position:
     "Her Drama – AB, Want Her – NS ×2". Sorted, because cart order shifts
     every time a line is re-added. iris-engraving.js builds the same string
     for the add itself, so a single engraved add needs no rewrite. */
  function summaryOf(lips) {
    var qty = {};
    lips.forEach(function (i) {
      var shade = i.variant_title && i.variant_title !== 'Default Title' ? i.variant_title : i.product_title;
      var k = shade + ' – ' + i.properties.Engraving;
      qty[k] = (qty[k] || 0) + i.quantity;
    });
    return Object.keys(qty).sort().map(function (k) { return qty[k] > 1 ? k + ' ×' + qty[k] : k; }).join(', ');
  }

  /* Work out the next fix for one cart snapshot. Keys change after every
     /cart/change, so only one fix is applied per pass and the cart is
     re-read before the next. */
  function nextFix(cart) {
    var items = cart.items || [];
    var engr = items.filter(function (i) { return String(i.variant_id) === ENGRAVING_VARIANT; });
    var lips = items.filter(function (i) {
      return String(i.variant_id) !== ENGRAVING_VARIANT && i.properties && i.properties.Engraving;
    });

    if (!lips.length) {
      return engr.length ? { id: engr[0].key, quantity: 0 } : null;
    }

    if (!engr.length) {
      // /cart/change.js cannot delete a property key (an empty object is
      // ignored; a blank value leaves "Engraving:" on the order), so the
      // line is removed and the same shade re-added without it. Any other
      // properties are kept.
      var l = lips[0];
      var props = {};
      Object.keys(l.properties).forEach(function (k) {
        if (k !== 'Engraving') props[k] = l.properties[k];
      });
      return { line: l, readd: { id: l.variant_id, quantity: l.quantity, properties: props } };
    }

    if (engr.length > 1) {
      // Drop a line whose summary is stale first; if none is, the last one.
      var cur = summaryOf(lips);
      var stale = engr.filter(function (e) { return ((e.properties && e.properties[SUMMARY]) || '') !== cur; });
      return { id: (stale[0] || engr[engr.length - 1]).key, quantity: 0 };
    }

    var want = summaryOf(lips);
    var e = engr[0];
    var has = (e.properties && e.properties[SUMMARY]) || '';
    if (has !== want) {
      var props = {};
      props[SUMMARY] = want;
      return { line: e, readd: { id: e.variant_id, quantity: 1, properties: props } };
    }
    // Same summary, wrong quantity: a plain quantity change (re-adding the
    // same properties would merge into this very line, then delete it).
    if (e.quantity !== 1) return { id: e.key, quantity: 1 };
    return null;
  }

  /* Shopflo keeps its own copy of the cart; an open drawer only re-reads
     Shopify's cart when (re)opened. */
  function refreshDrawer() {
    // The drawer is always in the DOM, parked off-screen when closed, and
    // position:fixed (so offsetParent is always null). Its backdrop overlay is
    // display:none unless the drawer is open; the wrapper's position is the
    // fallback.
    var overlay = document.getElementById('flo-cart-overlay-div');
    var wrapper = document.getElementById('flo-cart-wrapper');
    var open = (overlay && getComputedStyle(overlay).display !== 'none') ||
      (wrapper && wrapper.getBoundingClientRect().left < window.innerWidth - 1);
    if (open && typeof window.handleFloCartBtn === 'function') {
      try { window.handleFloCartBtn(); } catch (e) { /* ignore */ }
    }
  }

  function reconcile() {
    if (running) { again = true; return; }
    running = true;
    var changed = false;

    function pass(guard) {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var fix = guard > 0 ? nextFix(cart) : null;
          if (!fix) {
            var any = (cart.items || []).some(function (i) {
              return String(i.variant_id) === ENGRAVING_VARIANT || (i.properties && i.properties.Engraving);
            });
            flag(any);
            return;
          }
          changed = true;
          var readd = fix.readd;
          if (!readd) {
            return post('/cart/change.js', { id: fix.id, quantity: fix.quantity }).then(function () { return pass(guard - 1); });
          }
          // Add the replacement BEFORE removing the original. If the shopper
          // navigates away in between, the cart is left with a duplicate the
          // next check tidies up -- never with a lipstick or the engraving
          // flag missing. An add re-keys the existing lines, so the original
          // is found again by variant + properties and removed by its new key.
          var target = fix.line;
          return post('/cart/add.js', { items: [readd] })
            .then(function () {
              return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
            })
            .then(function (now) {
              var match = (now.items || []).filter(function (i) {
                return String(i.variant_id) === String(target.variant_id) &&
                  JSON.stringify(i.properties || {}) === JSON.stringify(target.properties || {});
              })[0];
              if (match) return post('/cart/change.js', { id: match.key, quantity: 0 });
            })
            .then(function () { return pass(guard - 1); });
        });
    }

    pass(10)
      .catch(function (e) { console.warn('[iris-engraving-cart]', e); })
      .then(function () {
        running = false;
        if (changed) {
          if (typeof window.shopfloUpdateCartCount === 'function') {
            try { window.shopfloUpdateCartCount(); } catch (e) { /* ignore */ }
          }
          refreshDrawer();
        }
        if (again) { again = false; schedule(300); }
      });
  }

  function schedule(ms) {
    clearTimeout(timer);
    timer = setTimeout(reconcile, ms);
  }

  // Any cart write on the page that is not ours -- Shopflo's drawer runs its
  // own /cart/change.js after posting FLO_ITEM_UPDATE -- triggers a check once
  // that request has COMPLETED. A fixed delay after the message raced slow
  // requests and read the cart before the removal had landed. Shopflo wraps
  // window.fetch too; whichever wraps last, every call passes through here.
  var CART_WRITE = /\/cart\/(change|add|update|clear)(\.js)?(\?|$)/;
  var nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var mine = init && init.irisInternal;
    var res = nativeFetch.apply(this, arguments);
    if (!mine && CART_WRITE.test(url)) {
      res.then(function () { if (flagged()) schedule(250); }, function () {});
    }
    return res;
  };

  // Belt and braces: the drawer's message alone also schedules a (later) check,
  // in case its write does not go through window.fetch.
  window.addEventListener('message', function (e) {
    var d = e.data;
    if (!d || typeof d !== 'object') return;
    if (d.type === 'FLO_ITEM_UPDATE' || d.type === 'FLO_CART_UPDATE') {
      flag(true);
      schedule(2500);
    }
  });

  // The theme's own cart (cart page / drawer) publishes cartUpdate.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (evt) {
      if (evt && evt.source !== 'product-form') schedule(600);
    });
  }

  if (flagged()) {
    var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 1500); };
    idle(function () { reconcile(); });
  }

  window.IrisEngravingCart = { reconcile: reconcile };
})();
